import styled, {css} from 'styled-components';

import type {Props} from './types';

import {ms} from '../../styles/normalizeSize';
import {getColor} from '../../styles/utils';
import {platform} from '../../utils/platform';
import {Text} from '../Text';
import {TextInput} from '../TextInput';
import {TextInputLikeView} from '../TextInputLikeView';
import {View} from '../View';

export const Container = styled(TextInputLikeView)<{error?: Props['error']}>`
  flex-direction: row;
  align-items: ${platform.isWeb ? 'baseline' : 'center'};
  background-color: ${p =>
    p.theme.id === 'light' ? getColor('background1') : getColor('background2')};

  ${p =>
    p.error &&
    css`
      border-color: ${getColor('error')};
    `}
`;

export const Input = styled(TextInput).attrs({
  containerStyle: {
    flex: 1,
  },
})`
  padding: 0;
  border-width: 0;
  height: ${ms(15)};
  font-size: ${ms(14)};
  border-radius: 0;
  background-color: transparent;

  ${platform.isNative &&
  css`
    position: relative;
    top: ${ms(platform.isIos ? 1.5 : 2.5)};
  `}
`;

export const FlagWrapper = styled(View)`
  flex-direction: row;
  align-items: ${platform.isWeb ? 'baseline' : 'center'};
`;

export const FlagContainer = styled(View)`
  position: relative;
  top: ${ms(1)};
`;

export const DialCode = styled(Text)`
  font-size: ${ms(14)};
  line-height: ${ms(15)};
  padding-right: ${ms(10)};

  ${platform.isNative &&
  css`
    position: relative;
    top: ${ms(2)};
  `}
`;
